import { formatDate } from '@btime/helpers'
import React from 'react'

import { findReplyByQuestionId, getReplyValue, toCurrency } from '../_helpers/pdfHelpers'
import { useChildrenServiceOrders } from '../_load/ChildrenServiceOrdersLoader'
import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import Separator from '../../../../components/pdf/Separator'
import Grid, { Col } from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import View from '../../../../components/pdf/View'
import Text from '../../../../components/pdf/Text'

const FourthPage = () => {
  const parentServiceOrder = useServiceOrder()
  const childrenServiceOrder = useChildrenServiceOrders()
  const childrenServiceOrders = childrenServiceOrder.filter(so => so.checklist.id === 8)

  const clientName = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 324))
  const cnpj = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 325))
  const dateTime = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 305))
  const formattedDateTime = formatDate('DD/MM/YYYY HH:MM', dateTime)
  const daily = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 310))
  const hours = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 311))
  const address = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 300)).search
  const cityAndState = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 312))
  const guests = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 277))
  const additionalInformation = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 313))
  const hasWater = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 314))
  const hasEnergy = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 315))
  const completedDateTime = childrenServiceOrders[0]?.events.filter(event => event?.status?.id === 8)[0]?.eventDate
  const formattedCompletedDateTime = formatDate('DD/MM/YYYY', completedDateTime)
  const trailer = getReplyValue(findReplyByQuestionId(childrenServiceOrders[0].replies, 317))?.name
  const quantity = getReplyValue(findReplyByQuestionId(childrenServiceOrders[0].replies, 318))
  const freight = getReplyValue(findReplyByQuestionId(childrenServiceOrders[0].replies, 319))
  const supplies = getReplyValue(findReplyByQuestionId(childrenServiceOrders[0].replies, 320))
  const cleaningStaff = getReplyValue(findReplyByQuestionId(childrenServiceOrders[0].replies, 321))
  const wasteDisposal = getReplyValue(findReplyByQuestionId(childrenServiceOrders[0].replies, 322))
  const total = getReplyValue(findReplyByQuestionId(childrenServiceOrders[0].replies, 323))

  return (
    <View pageBreakAfter>
      <Grid direction="column" align="start">
        <Col>
          <Image src="/pdfs/sannygold/logo.jpg" maxWidth={100} />
        </Col>
      </Grid>
      <Separator weight={6} />
      <Col>
        <Text bold align="center" color="#938953" size={18}>
          Descrição do Evento:
        </Text>
        <Separator weight={6} />
        <Table width="100%" color="#938953">
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }} width="50%">
              <Text style={{ fontWeight: '700' }}>Cliente:</Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{clientName}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }} width="50%">
              <Text style={{ fontWeight: '700' }}>CNPJ:</Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{cnpj}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }}>
              <Text style={{ fontWeight: '700' }}>Data do Evento:</Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{formattedDateTime}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }}>
              <Text style={{ fontWeight: '700' }}>Diárias</Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{daily}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }}>
              <Text style={{ fontWeight: '700' }}>Duração do Evento (Horas em Operação):</Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{hours}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }}>
              <Text style={{ fontWeight: '700' }}>Endereço do Evento:</Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{address}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }}>
              <Text style={{ fontWeight: '700' }}>Cidade/Estado</Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{cityAndState}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }}>
              <Text style={{ fontWeight: '700' }}>Número de Convidados</Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{guests}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }}>
              <Text style={{ fontWeight: '700' }}>Informações Adicionais </Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{additionalInformation}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }}>
              <Text style={{ fontWeight: '700' }}>Possui ponto de água?</Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{hasWater ? 'Sim' : 'Não'}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }}>
              <Text style={{ fontWeight: '700' }}>Possui ponto de energia?</Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{hasEnergy ? 'Sim' : 'Não'}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol bgColor="#c4bb95" color="#938953" style={{ borderBottom: '1px solid #49442a' }}>
              <Text style={{ fontWeight: '700' }}>Data da Proposta: </Text>
            </TableCol>
            <TableCol color="#938953">
              <Text>{formattedCompletedDateTime}</Text>
            </TableCol>
          </TableRow>
        </Table>
      </Col>
      <Separator weight={30} />
      <Col>
        <Text bold align="center" color="#938953" size={18}>
          Orçamento Detalhado:
        </Text>
        <Separator weight={6} />
        <Table width="100%" color="#938953">
          <TableRow color="#938953">
            <TableCol width="40%" color="#938953">
              <Text style={{ fontWeight: '700' }} align="center" color="#938953">
                Item
              </Text>
            </TableCol>
            <TableCol color="#938953" style={{ borderLeft: 'none' }}>
              <Text style={{ fontWeight: '700' }} color="#938953" align="center">
                Descrição
              </Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953" bgColor="#c4bb95">
            <TableCol color="#938953">
              <Text style={{ fontWeight: '700' }}>Locação do Trailer Sanitário</Text>
            </TableCol>
            <TableCol color="#c4bb95">
              <Text>{`${quantity} ${trailer}`}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol color="#938953">
              <Text style={{ fontWeight: '700' }}>Frete</Text>
            </TableCol>
            <TableCol style={{ borderLeft: 'none' }}>
              <Text>{toCurrency(freight)} por Km rodado (Acima de 80km de nossa base)</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953" bgColor="#c4bb95">
            <TableCol color="#938953">
              <Text style={{ fontWeight: '700' }}>Suprimentos</Text>
            </TableCol>
            <TableCol color="#c4bb95">
              <Text>{supplies}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953">
            <TableCol color="#938953">
              <Text style={{ fontWeight: '700' }}>Equipe de limpeza/manutenção</Text>
            </TableCol>
            <TableCol style={{ borderLeft: 'none' }}>
              <Text>{cleaningStaff}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#938953" bgColor="#c4bb95">
            <TableCol color="#938953">
              <Text style={{ fontWeight: '700' }}>Descarte de Resíduos</Text>
            </TableCol>
            <TableCol color="#c4bb95">
              <Text>{wasteDisposal}</Text>
            </TableCol>
          </TableRow>
        </Table>
        <Separator weight={10} />
        <Table width="100%" color="#938953">
          <TableRow color="#938953" bgColor="#c4bb95">
            <TableCol width="40%" style={{ padding: '10px' }}>
              <Text bold>TOTAL</Text>
            </TableCol>
            <TableCol color="#c4bb95">
              <Text style={{ fontWeight: '700' }}>Valor Total Global: {toCurrency(total)}</Text>
            </TableCol>
          </TableRow>
        </Table>
      </Col>
      <Separator weight={100} />
    </View>
  )
}

export default FourthPage
